module.exports = __webpack_public_path__ + "static/media/time.8feb2afc.svg";